import React from 'react';
import { Route } from 'react-router-dom';
import firebase from './Firestore';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
if (process.env.NODE_ENV !== 'production') {
    var mock = require("../mocks/ordermock.json")
}

var moment = require('moment');

class OrderPage extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            form: {
                time: null,
                description: "",
                phone: "",
                email: "",
                shop_id: "",
                user_id: "TODO"
            },
            checked: null, 
            currtime: null,
            soonestPickupTime: null,
            latestPickupTime: null,
            availableTimes: null
        }
    }

    onCheck(value) {
        this.setState({
            checked: value
        });
    }

    getNumericAvailableTimes(date) {
        var min = 0;
        // need to exclude those that are before the current time
        if (this.state.currtime && (date.format('L') === this.state.currtime.format('L'))) {
            min = this.state.currtime.hour() + (this.state.currtime.minute()/60);
        }
        if (this.props.hours) {
            var dayHours = this.props.hours[date.day()];
            var availableTimes = []
            for (var i = 1; i < dayHours.length; i = i + 2) {
                for (var j = dayHours[i-1]; j <= dayHours[i]; j = j + 0.25) {
                    if (min < j && j !== dayHours[0] && j !== dayHours[dayHours.length-1]) {
                        availableTimes.push(j);
                    }
                }
            }
            return availableTimes;
        }
        return null
    }

    getAvailableTimes(date) {
        var min = 0;
        // need to exclude those that are before the current time
        if (this.state.currtime && (date.format('L') === this.state.currtime.format('L'))) {
            min = this.state.currtime.hour() + (this.state.currtime.minute()/60) + (this.props.intervalToOrder/60);
        }
        if (this.props.hours) {
            var dayHours = this.props.hours[date.day()];
            var availableTimes = []
            for (var i = 1; i < dayHours.length; i = i + 2) {
                for (var j = dayHours[i-1]; j <= dayHours[i]; j = j + 0.25) {
                    if (min < j && j !== dayHours[0] && j !== dayHours[dayHours.length-1]) {
                        var tempdate = date.clone().hours(Math.floor(j)).minutes(60*(j%1)).toDate();
                        availableTimes.push(tempdate);
                    }
                }
            }
            return availableTimes;
        }
        return null
    }

    updateAvailableTimes(date) {
        this.setState({
            availableTimes: this.getAvailableTimes(date)
        });
    }

    updateTime(time) {
        var form = {...this.state.form};
        form.time = time;
        this.setState ({form});
        this.updateAvailableTimes(time);
    }

    updateDescription(description) {
        var form = {...this.state.form};
        form.description = description;
        this.setState ({form});
    }

    updatePhoneNumber(phone) {
        if (phone.length >= 4 && phone[3] !== "-") {
            phone = phone.substring(0, 3) + "-" + phone.substring(3);
        }
        if (phone.length >= 8 && phone[7] !== "-") {
            phone = phone.substring(0, 7) + "-" + phone.substring(7);
        }
        var form = {...this.state.form};
        form.phone = phone;
        this.setState ({form}); 
    }

    updateEmail(email) {
        var form = {...this.state.form};
        form.email = email;
        this.setState ({form});
    }

    onSubmit(e, history) {
        var form = {...this.state.form};
        form.shop_id = this.props.shop_id;
        this.setState ({form});
        console.log(this.props.shop_id)
        e.preventDefault();
        if (process.env.NODE_ENV === 'production') {
            firebase.firestore().collection('orders') 
                .add({
                    item_description: this.state.form.description, 
                    pickup_time: this.state.form.time.toDate(),
                    shop_id: this.props.shop_id,
                    user_id: "TODO", 
                    email: this.state.form.email,
                    phone: this.state.form.phone
                }).then(res => {
                    history.push("/confirmation/" + res.id);
                });
        } else {
            history.push("/confirmation/" + mock.order_id);
        }
    }

    updateCurrTime () {
        this.setState({
            currtime: moment()
        });
        var temp = moment(Date.now()).add(this.props.intervalToOrder, 'm');
        if (this.props.hours) {
            var dayHours = this.props.hours[temp.day()];
            var numerical = temp.hour() + (temp.minute()/60);
            var offset = 0;
            while (dayHours.length === 0 || numerical > dayHours[dayHours.length - 1]) {
                offset += 1;
                dayHours = this.props.hours[(temp.day() + offset) % 7];
                if (dayHours) {
                    numerical = dayHours[0] + 0.25;
                }
            }  
            if (numerical < dayHours[0]) {
                numerical = dayHours[0] + 0.25;
            }
            temp = moment(Date.now()).add(offset, 'd').hours(Math.floor(numerical)).minutes(15*Math.ceil((60*(numerical%1))/15));
            var available = this.getNumericAvailableTimes(temp);
            if (!available.includes(numerical)) {
                numerical = available.reduce(function(prev, curr) {
                    return (curr - numerical >= 0 && prev - numerical < 0 ? curr : prev);
                });
            }
            temp = temp.hours(Math.floor(numerical)).minutes(15*Math.ceil((60*(numerical%1))/15));
            var last = temp.clone().add(7, 'd');
            this.setState({
                soonestPickupTime: temp,
                latestPickupTime: last
            });
            this.updateTime(temp.clone());
        }
    }

    componentDidMount() {
        this.updateCurrTime();
        setInterval(() => {
            this.updateCurrTime();
        }, 300000);                    // update current time every 5 minutes
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.hours !== this.props.hours) {
            this.updateCurrTime();
        }
    }

    componentWillUnmount() {
        clearInterval();
    }

    handleSelectDate(date) {
        var temp = moment(date);
        var numerical = temp.hour() + (temp.minute()/60);
        var available = this.getNumericAvailableTimes(temp);
        if (!available.includes(numerical)) {
            numerical = available.reduce(function(prev, curr) {
                return (curr - numerical >= 0 && prev - numerical < 0 ? curr : prev);
            });
        }
        temp = temp.hours(Math.floor(numerical)).minutes(15*Math.ceil((60*(numerical%1))/15));
        this.updateTime(temp);
    }

    render() {
        var {pickup_note} = this.props;
        return(
            <React.Fragment>
                {pickup_note &&
                    <div className="info-box">
                        {pickup_note}
                    </div>
                }
                <Route render={({history}) => (
                <form onSubmit={(e) => this.onSubmit(e, history)}>
                    <label> When would you like your order? </label>
                    <div onChange={(e) => this.onCheck(e.target.value)} >
                        <label className="radio-button-container">
                            <input type="radio" name="time" value="ASAP" required/>
                            <span className="radio-button"/>
                            ASAP ({this.state.soonestPickupTime && this.state.soonestPickupTime.format('MMMM DD [at] h:mm A')})
                        </label>
                        <label className="radio-button-container">
                            <input type="radio" name="time" value="Schedule" required/>
                            <span className="radio-button"/>
                            Schedule for later 
                        </label>
                    </div>

                    {this.state.checked === "Schedule" && 
                        <React.Fragment> 
                            {this.state.soonestPickupTime && 
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <DatePicker
                                                    className="datepicker"
                                                    dateFormat=" MMMM d"
                                                    selected={this.state.form.time.toDate()}
                                                    onChange={(date) => this.handleSelectDate(date)}
                                                    minDate={this.state.soonestPickupTime.toDate()}
                                                    maxDate={this.state.latestPickupTime.toDate()}
                                                    filterDate={date => {
                                                        const day = date.getDay();
                                                        if (!this.props.hours || this.props.hours[day].length > 0) {
                                                            return true;
                                                        }
                                                        return false;
                                                    }}
                                                    required
                                                />
                                            </td>
                                            <td>
                                                <DatePicker
                                                    className="datepicker"
                                                    dateFormat=" h:mm aa"
                                                    selected={this.state.form.time.toDate()}
                                                    onChange={(date) => this.handleSelectDate(date)}
                                                    includeTimes={this.state.availableTimes}
                                                    timeIntervals={15}
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    required
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> 
                            }
                        </React.Fragment>
                    } 

                    <hr/>

                    <label> What item would you like to buy? </label>
                    <textarea 
                        className="input-textarea" 
                        value={this.state.form.description} 
                        onChange={(e) => this.updateDescription(e.target.value)}>
                    </textarea>

                    <label name="phone"> Phone Number* </label>           
                    <input 
                        required 
                        className="input-text" 
                        type="tel" 
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" 
                        maxLength="12" 
                        onChange={(e) => this.updatePhoneNumber(e.target.value)} 
                        value={this.state.form.phone}>
                    </input>

                    <label> Email* </label>           
                    <input 
                        required 
                        name="email" 
                        type="email" 
                        className="input-text" 
                        onChange={(e) => this.updateEmail(e.target.value)}
                        value={this.state.form.email}
                    >
                        
                    </input>
                    
                        <button 
                            className="button-submit" 
                            type="submit"
                        > 
                            Request Pickup
                        </button>
                </form>
                )}/>
            </React.Fragment>
        );
    }

}

export default OrderPage;
